var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSpots = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "4 4 22 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Events / List / Background")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000222222224 0.0001 10 0.0001 10 0.9999 0.000222222224 0.9999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.000222222224 12.9999 10 12.9999 10 13.9999 0.000222222224 13.9999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "-9.09494702e-13 9.7499 7.97433333 9.7499 7.97433333 10.7499 -9.09494702e-13 10.7499"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0.000222222224 6.4999 10 6.4999 10 7.4999 0.000222222224 7.4999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "-9.09494702e-13 3.2499 7.97433333 3.2499 7.97433333 4.2499 -9.09494702e-13 4.2499"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Events-/-List-/-Background",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000111, 8.000100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5001 L10,0.5001 L0,0.5001 Z",
    id: "Fill-1-Copy",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-3-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000222222221,
    y1: 0.4999,
    x2: 10.0002222,
    y2: 0.4999,
    id: "Stroke-2-Copy",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.4997 L10,13.4997 L0,13.4997 Z",
    id: "Fill-5-Copy",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.0002222,
    y1: 13.4999,
    x2: 0.000222222221,
    y2: 13.4999,
    id: "Stroke-6-Copy",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.27373675e-13,10.2498 L7.97444444,10.2498 L-2.27373675e-13,10.2498 Z",
    id: "Fill-9-Copy",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.97433333,
    y1: 10.2499,
    x2: -0.000111111113,
    y2: 10.2499,
    id: "Stroke-10-Copy",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.9999 L10,6.9999 L0,6.9999 Z",
    id: "Fill-13-Copy",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.0002222,
    y1: 6.9999,
    x2: 0.000222222221,
    y2: 6.9999,
    id: "Stroke-14-Copy",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.27373675e-13,3.75 L7.97444444,3.75 L-2.27373675e-13,3.75 Z",
    id: "Fill-17-Copy",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.97433333,
    y1: 3.7499,
    x2: -0.000111111113,
    y2: 3.7499,
    id: "Stroke-18-Copy",
    stroke: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Spots.7c55720a.svg";
export { ForwardRef as ReactComponent };